
<div class="login-container">
  <div class="glass-card">
    <img src="{{ resources[0] }}" alt="cloudapps logo" class="logo" />

    <div class="m-t-10" fxLayout="column" fxLayoutAlign="center center">

      <!-- DYNAMIC ICON -->
      <mat-icon
        [ngStyle]="{
          color: dynamicStyles.iconColor,
          'font-size': '45px',
          'width': '45px',
          'height': '45px'
        }">
        {{ dynamicStyles.iconName }}
      </mat-icon>

      <!-- DYNAMIC TEXT -->
      <div class="scrollable">
        <span
            class="m-b-20"
            [attr.style]="'font-size:' + dynamicStyles.textFontsize + ' !important; color:' + dynamicStyles.textColor">
            {{ errorMessage }}
          </span>
      </div>

      <!-- DATE-->
      <div class="m-t-30" *ngIf="problemStart">
        <small>
          Issue detected at:
          <strong>{{ problemStart | date:'MMMM d, y – h:mm a' }}</strong>.
          <br>
          <span class="timezone">({{ timezone }})</span>
        </small>
      </div>

      <!-- RETRY BUTTON -->
      <button mat-raised-button color="primary" class="m-t-20" *ngIf="!retriying" (click)="retry()">
        <mat-icon class="f-400 ico-renew">autorenew</mat-icon>
        <span class="demo f-400">Retry</span>
      </button>

      <!-- SPINNER -->
      <div fxLayout="row" class="m-t-20 p-t-5 p-b-5 no-select" fxLayoutAlign="center center" *ngIf="retriying">
        <mat-spinner class="m-r-5" mode="indeterminate" [diameter]="15"></mat-spinner>
        Retrying ...
      </div>
    </div>

  </div>
</div>
